import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#247865",
  d: "M12.987 3.952A3.25 3.25 0 0 1 15.285 3h6.965A2.75 2.75 0 0 1 25 5.75v6.964c0 .53-.13 1.052-.377 1.52a7.5 7.5 0 0 0-10.346 10.453 3.25 3.25 0 0 1-4.076-.424l-6.464-6.465a3.25 3.25 0 0 1 0-4.596zM19.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1 17a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13m3.354-9.854a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708l6-6a.5.5 0 0 1 .708 0M17 18.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m.75-1.75a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m5.5 4.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-1.75.75a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }